import { Description } from './description';
export default Description;
